module.exports = __webpack_public_path__ + "assets/9c6bbc1e634573c880f21b5c1bed2f3c.mp3";